import { render, staticRenderFns } from "./memberCenter.vue?vue&type=template&id=59003662&scoped=true&"
import script from "./memberCenter.vue?vue&type=script&lang=js&"
export * from "./memberCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59003662",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/DiTuYouXuan/DiTuAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59003662')) {
      api.createRecord('59003662', component.options)
    } else {
      api.reload('59003662', component.options)
    }
    module.hot.accept("./memberCenter.vue?vue&type=template&id=59003662&scoped=true&", function () {
      api.rerender('59003662', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/member/memberManage/memberCenter.vue"
export default component.exports